import { render, staticRenderFns } from "./TransferInternal.vue?vue&type=template&id=37e91716&"
import script from "./TransferInternal.vue?vue&type=script&lang=js&"
export * from "./TransferInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports